<svelte:options customElement="hb-banner" />

<script lang="ts">
  /**
   * Svelte Banner WebComponent
   * =====================
   *
   * @contributors: Dario Caruso <dev@dariocaruso.info> (https://dariocaruso.info)
   *
   * @license: MIT License
   *
   */

  import { dictionary } from "./libs/i18n";
  import type { Component } from "./types/webcomponent.type";

  let {
    id = "",
    logouri = undefined,
    title = undefined,
    description = undefined,
  }: Component = $props();
</script>

<div class="container align-items-center d-none d-lg-block">
  <div class="row">
    <div class="col-lg-4" style="text-align: right;">
      <img alt="" src={logouri} style="height: 150px;" />
    </div>
    <div class="col-lg-8">
      <h2 style="padding-top: 10px;"><strong>{title}</strong></h2>
      <h3 style="margin-top: 20px;">{description}</h3>
    </div>
  </div>
</div>

<div class="container d-lg-none">
  <div class="row">
    <div class="col-lg-4" style="text-align: center;">
      <img alt="" src={logouri} style="height: 150px;" />
    </div>
    <div class="col-lg-8">
      <h2 style="padding-top: 10px;text-align:center">
        <strong>{title}</strong>
      </h2>
      <h3 style="margin-top: 20px;text-align:center">{description}</h3>
    </div>
  </div>
</div>

<style lang="scss">
  @forward "./styles/bootstrap.scss";
  @forward "./styles/webcomponent.scss";
</style>
